import { Component, OnInit, Inject } from '@angular/core';
import { MenuProduto } from 'src/app/models/menuproduto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ProdutoCampoPersonalizadoService } from 'src/app/services/produto-campo-personalizado.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProdutoCampoPersonalizado } from 'src/app/models/produto-campo-personalizado';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MenuProdutoService } from 'src/app/services/menuprodutoservice';

@Component({
  selector: 'app-adicionar-menu-produto-modal',
  templateUrl: './adicionar-menu-produto-modal.component.html',
  styleUrls: ['./adicionar-menu-produto-modal.component.scss']
})
export class AdicionarMenuProdutoModalComponent implements OnInit {
  menuProduto: MenuProduto = new MenuProduto();
  camposPersonalizados = [];
  campoSelecionado: ProdutoCampoPersonalizado;
  superior = 0;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private campoPersonalizadoService: ProdutoCampoPersonalizadoService,
    public dialogRef: MatDialogRef<AdicionarMenuProdutoModalComponent>,
    public menuProdutoService: MenuProdutoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  async ngOnInit() {
    await this.buscarCamposPersonalizados();

    if(this.data.menu) {
      await this.buscarMenu(this.data.menu.idMenu);

      if (this.menuProduto.campoPersonalizado) {
        this.campoSelecionado = this.camposPersonalizados
          .find(c => c.id == this.menuProduto.campoPersonalizado.idCampoPersonalizado);

        this.menuProduto.idCampoPersonalizado = this.menuProduto.campoPersonalizado.idCampoPersonalizado;

        this.campoSelecionado.itensSelecionados = [];

        this.menuProduto.campoPersonalizado.itens.forEach(item => {
          const itemSelecionado = this.campoSelecionado.itens
            .find(i => i.id == item.idCampoPersonalizadoItem).id;

          this.campoSelecionado.itensSelecionados.push(itemSelecionado);
        });

        this.campoSelecionado.textoSelecionado = this.menuProduto.campoPersonalizado.texto;
        this.campoSelecionado.itemSelecionado = this.menuProduto.campoPersonalizado.idCampoPersonalizadoItem;

        if(this.data.entrarSalvando) {
          this.salvar();
        }
      }
    }

    this.superior = this.data.superior;
  }

  async buscarMenu(idMenu) {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarMenu');

      this.menuProdutoService.consultarMenuPorId(idMenu).subscribe(menuProduto => {
        this.menuProduto = menuProduto;
        this.carregandoService.esconde('buscarMenu');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarMenu');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  async buscarCamposPersonalizados() {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarCamposPersonalizados');

      this.campoPersonalizadoService.consultarTodosProdutoCampoPersonalizado().subscribe(campos => {
        this.camposPersonalizados = campos;
        this.carregandoService.esconde('buscarCamposPersonalizados');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarCamposPersonalizados');
        this.notificacaoService.erro(erro);
        reject();
      });
    });
  }

  selecionarCampo(campoSelecionado: any) {
    this.campoSelecionado = campoSelecionado;
  }

  salvar() {
    if(this.menuProduto.idCampoPersonalizado) {
      this.menuProduto.campoPersonalizadoMontar = this.campoSelecionado;
    }

    this.menuProduto.superior = this.superior;

    this.carregandoService.mostra('adicionarmenu');
    this.menuProdutoService.salvar(this.menuProduto).subscribe((id: number) => {
      this.notificacaoService.sucesso('Menu salvo com sucesso!!!');
      this.carregandoService.esconde('adicionarmenu');
      if(!this.menuProduto.idMenu) {
        this.menuProduto.idMenu = id;
      }
      this.dialogRef.close(this.menuProduto);
    }, (error) => {
      this.notificacaoService.erro(error);
      this.carregandoService.esconde('adicionarmenu');
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
